import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Download = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Download({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M19.75 12.5V19.25H5.25L5.25 12.5C5.25 12.2239 5.02614 12 4.75 12H4.25C3.97386 12 3.75 12.2239 3.75 12.5L3.75 19.5C3.75 20.1904 4.30965 20.75 5 20.75H20C20.6904 20.75 21.25 20.1904 21.25 19.5V12.5C21.25 12.2239 21.0261 12 20.75 12H20.25C19.9739 12 19.75 12.2239 19.75 12.5Z'
        fill={color}
      />
      <path
        d='M13.3838 15.1768C12.8957 15.6649 12.1042 15.6649 11.6161 15.1768L7.32317 10.8839C7.12791 10.6886 7.12791 10.3721 7.32317 10.1768L7.67672 9.82324C7.87198 9.62798 8.18856 9.62797 8.38383 9.82324L11.75 13.1894L11.75 3.5C11.75 3.22386 11.9739 3 12.25 3L12.75 3C13.0261 3 13.25 3.22386 13.25 3.5L13.25 13.1893L16.6161 9.82324C16.8113 9.62797 17.1279 9.62797 17.3232 9.82324L17.6767 10.1768C17.872 10.3721 17.872 10.6886 17.6767 10.8839L13.3838 15.1768Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'download-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Download;
